import { createI18n } from 'vue-i18n'

import en from './locales/en'

// English only, for now.
//
// The infrastructure stays: every user-visible string in this app is reached
// through `t()`, so adding a locale is adding a file and one entry here. What
// is gone is the Slovenian bundle — it was never reviewed by anybody who speaks
// the product, and a management portal is a bad place to discover a machine
// translation. Every technician who opens this speaks English.
//
// `fallbackLocale` is `en` as well rather than absent: a key that has not been
// added yet renders as the key without it, which is worse than rendering as the
// only text there is.
export type AvailableLocales = 'en'

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           'en',
    fallbackLocale:   'en',
    messages:         { en },
    availableLocales: ['en'],
})

export default i18n
